export const WHATSAPP_NUMBER = "526671234567";

export const buildWhatsAppLink = (message: string): string =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const INSTAGRAM_URL = "https://instagram.com/alea.aesthetichouse";
export const FACEBOOK_URL = "https://facebook.com/alea.aesthetichouse";
export const TIKTOK_URL = "https://tiktok.com/@alea.aesthetichouse";